module.exports = __webpack_public_path__ + "static/media/8.b2a8a30b.png";